import classNames from 'classnames';
import { Plus } from 'lucide-react';
import { MediaManagerTemplate } from 'modules/core/domain/interfaces/supabase/media-manager/entity';
import MediaManagerTemplateListElement from 'modules/manager/ui/components/media-manager-template-list-element';
import React from 'react';
import { ClipLoader } from 'react-spinners';
import { UDButton, UDText } from 'ud-ui/components';
import ListView from 'ud-ui/components/list-view/list-view';

const HEADER_NAME = 'Шаблоны';

interface IProps {
  templates: MediaManagerTemplate[];
  isLoading?: boolean;
  className?: string;

  onCreate: () => void;
  onSelect: (template: MediaManagerTemplate) => void;
  onEdit: (template: MediaManagerTemplate) => void;
  onDelete: (template: MediaManagerTemplate) => void;
}

function MediaManagerTemplateList(props: IProps) {
  const { templates, isLoading, className, onCreate, onSelect, onEdit, onDelete } = props;
  const nodeClasses = classNames(className, 'flex-1');
  const isEmpty = templates?.length === 0;

  if (isLoading) {
    return (
      <ListView header={HEADER_NAME} className={nodeClasses}>
        <div className={'flex-center h-full bg-white'}>
          <ClipLoader />
        </div>
      </ListView>
    );
  }

  if (isEmpty) {
    return (
      <ListView header={HEADER_NAME} className={nodeClasses}>
        <div className={'flex-center flex h-full flex-col gap-2 bg-white'}>
          <UDText isNew type={'body-2'}>
            У вас ещё нет шаблонов
          </UDText>
          <UDButton variant="primary" onClick={onCreate}>
            <Plus size={16} className={'mr-2'} /> Добавить шаблон
          </UDButton>
        </div>
      </ListView>
    );
  }

  return (
    <ListView header={HEADER_NAME} className={nodeClasses}>
      <div className={'h-full bg-white'}>
        {templates?.map((template, index) => (
          <MediaManagerTemplateListElement
            key={template.id}
            id={template.id}
            name={template.name}
            background={index % 2 === 0 ? 'light' : 'dark'}
            onClick={() => onSelect(template)}
            onEdit={() => onEdit(template)}
            onDelete={() => onDelete(template)}
          />
        ))}
      </div>
    </ListView>
  );
}

export default MediaManagerTemplateList;
